import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Avatar, IconButton, Menu, MenuItem,
  Tabs, Tab, Chip } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

export default function ViewerLayout() {
  var auth = useAuth();
  var user = auth.user, logout = auth.logout;
  var navigate = useNavigate();
  var location = useLocation();
  var as = React.useState(null); var anchorEl = as[0]; var setAnchorEl = as[1];

  var tab = location.pathname.indexOf('/viewer/applications') === 0 ? 'applications' : 'dashboards';
  var E = React.createElement;

  return E(Box, {sx:{minHeight:'100vh', bgcolor:'background.default'}},
    E(AppBar, {position:'static', sx:{bgcolor:'primary.main'}},
      E(Toolbar, null,
        E(Typography, {variant:'h6', sx:{flexGrow:1, cursor:'pointer'},
          onClick:function(){ navigate('/viewer'); }}, 'OKC 2027 \u2014 Insights'),
        E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
          E(Chip, {label:'Read only', size:'small',
            sx:{bgcolor:'rgba(255,255,255,0.18)', color:'#fff'}}),
          E(Typography, {variant:'body2'}, user && user.name),
          E(IconButton, {color:'inherit', onClick:function(e){ setAnchorEl(e.currentTarget); }},
            E(Avatar, {sx:{width:32, height:32, bgcolor:'secondary.main', fontSize:14}},
              user && user.name ? user.name.charAt(0).toUpperCase() : '?')),
          E(Menu, {anchorEl:anchorEl, open:Boolean(anchorEl), onClose:function(){ setAnchorEl(null); }},
            (user && user.role) === 'admin'
              ? E(MenuItem, {onClick:function(){ navigate('/admin'); setAnchorEl(null); }}, 'Admin panel')
              : null,
            E(MenuItem, {onClick:function(){ logout(); navigate('/login'); }},
              E(Logout, {sx:{mr:1, fontSize:18}}), 'Sign out'))))),

    E(Box, {sx:{bgcolor:'background.paper', borderBottom:1, borderColor:'divider'}},
      E(Box, {sx:{maxWidth:1200, mx:'auto', px:3}},
        E(Tabs, {value:tab, onChange:function(_, v){ navigate('/viewer/' + v); }},
          E(Tab, {value:'dashboards', label:'Dashboards'}),
          E(Tab, {value:'applications', label:'Applications'})))),

    E(Box, {sx:{maxWidth:1200, mx:'auto', p:3}}, E(Outlet)));
}
